export const LOADING_QUIPS: string[] = [
  'Generating creative pixels',
  'Training neural networks',
  'Wrangling diffusion models',
  'Consulting digital muses',
  'Calculating artistic probabilities',
  'Calibrating image matrices',
  'Optimizing latent spaces',
  'Cooling off the GPUs',
  'Farming GPUs',
  'Translating imagination to pixels',
  'Brewing digital creativity',
  'Summoning AI art spirits',
  'Negotiating with random seeds',
  'Compiling visual poetry',
  'Rendering dreams into reality',
  'Solving artistic equations',
  'Downloading inspiration',
  'Browsing art',
  'Mixing pixels',
  'Blending colors',
  'Mixing magic',
  'Doing artificial intelligence',
  'Dreaming in latent space',
  'Balancing prompt weights',
  'Fine-tuning artistic parameters',
  'Calculating aesthetic vectors',
  'Assembling digital brushstrokes',
  'Distilling creative tensors',
  'Sampling the art manifold',
  'Tuning diffusion steps',
  'Crafting pixel perfection',
  'Harmonizing style vectors',
];

export const getRandomLoadingQuip = (): string => {
  const randomIndex: number = Math.floor(Math.random() * LOADING_QUIPS.length);
  return LOADING_QUIPS[randomIndex];
};
